<div class="wallet_s_single_wrapper synergy-single microcredit-single row">
  <div class="s_single col-md-12">

    <div appSticky position="top" class="row s_single-title-container">
      <div class="col-md-12">
        <h1 class="s_single-title">{{offer.title}}</h1>
      </div>
    </div>
    <div class="row s_single-img-area">
      <div class="col-md-12 s_single-img-container">
        <div class="s_single-img">
          <img src={{offer.imageURL}} alt={{offer.title}} />
        </div>
        <div class="s_single-date">
          {{'GENERAL.TO' | translate}} {{offer.expiresAt | date: 'd.M'}}
        </div>
      </div>
    </div>
    <div class="row s_single-details">
      <div class="col-md-12">
        <div class="row s_single-info-container">
          <div class="col-md-8 s_single-info">
            <div class="info-row terms">
              <h4>{{'CAMPAIGN.TERMS' | translate}}</h4>
              <p [innerHTML]="offer.description"></p>
            </div>
          </div>
          <div *ngIf="offer.cost > 0" class="col-md-4 s_single-credit">
            <div class="price-item">
              <span class="amount">
                <img src="../../../assets/media/images/Synergy-Icon.png" alt="Synergy" />
                {{ offer.cost }}
              </span>
            </div>
          </div>
        </div>

        <div class="row s_single-description">
          
          <div class="col-md-4 partner-info s_single-info-container ">
            <h6>{{'CAMPAIGN.PARTNER' | translate}}</h6>
            <h5>{{offer.partner.name}}</h5>
            <img src="{{avatar}}" alt="{{offer.partner.name}}">

            <div *ngIf="offer.partner.address" class="info-row info-addess" (click)="scrollTo('map-widget-campaign')">
              <span class="mdi mdi-pin"></span>
              {{offer.partner.address.street}}, {{offer.partner.address.city}}
            </div>

            <div *ngIf="offer.partner.phone" class="info-row"><span class="mdi mdi-phone"></span>
              {{offer.partner.phone}}
            </div>

            <div class="info-row"><span class="mdi mdi-email"></span>{{offer.partner.email}}</div>

            <div *ngIf="contactsList">
              <div class="contacts" *ngFor="let contact of contactsList">
                <a *ngIf="contact.value" href="{{contact.prefix}}{{contact.value}}" target="_blank"><span
                    class="mdi mdi-{{contact.icon}}"></span> </a>
              </div>
            </div>

          </div>
        
          <div class="col-md-8">
            <p [innerHTML]="offer.instructions"></p>
          </div>
        
        </div>

      </div>
    </div>

    <!--begin::Map Widget-->
    <sng-map id="map-widget-campaign" [partner_id]='offer.partner._id'></sng-map>
    <!--end::Map Widget-->

  </div>
</div>